import { openTimesheetPostingModal } from '../State/timesheetPostingModal'

export default (id) => (dispatch) => {

  dispatch(openTimesheetPostingModal({ id }))
  
}
